import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["pre", "button"]

  connect() {
    this.highlight = this.highlight.bind(this)
    this.highlight()

    if (!window.hljs) window.addEventListener("load", this.highlight, { once: true })

    const collapseHeight = window.matchMedia("(max-width: 639px)").matches ? 352 : 448

    if (this.preTarget.scrollHeight > collapseHeight) {
      this.element.classList.add("is-collapsed")
      this.buttonTarget.classList.remove("hidden")
    }
  }

  disconnect() {
    window.removeEventListener("load", this.highlight)
  }

  expand() {
    this.element.classList.remove("is-collapsed")
    this.buttonTarget.remove()
  }

  highlight() {
    const code = this.preTarget.querySelector("code")

    if (window.hljs && code && !code.dataset.highlighted) window.hljs.highlightElement(code)
  }
}
